<fgb-page-header [pageTitle]="'nav.contact.us'" [showBalance]="false"></fgb-page-header>
<div class="container pt-lg-3">
  <div class="card border border-grey p-3 bg-secondary">
    <div
      class="contact-us-description font-size-14 text-white"
      [innerHTML]="'contact.us.description' | translate | markdownTranslate"
    ></div>
  </div>
</div>
